enum CONTENTO_TYPES {
    CLIP = 'Clip',
    TRAILER = 'Trailer',
    EPISODE = 'Episode',
    SINGLE = 'Single',
    TVSERIES = 'TvSeries',
    TVSHOW = 'TvShow',
    VARIANT = 'Variant',
    KIDSTVSHOW = 'KidsTvShow',
}

export default CONTENTO_TYPES;
